// AI Generated
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'icon-circle',
    template: '<div class="icon-circle" [ngClass]="color"><span class="fa-lg icon" [ngClass]="icon" aria-hidden="true"></span><span tabindex="0" class="sr-only">{{monAriaText}}</span></div>',
    standalone: false,
})
export class IconCircleComponent implements OnInit {
    @Input() color?: string;
    @Input() icon!: string;
    @Input() size?: string;
    @Input() monAriaText?: string;

    ngOnInit (): void {
        this.color = this.color || 'text-link';
        this.monAriaText = this.monAriaText || '';
    }
}
